













import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
@Component
export default class selectMore extends Vue {
  @Prop({ type: Function }) remoteMethod;
  private pageInput = {
    pageSize: 10,
    pageNum: 1
  };
  handleRemoteMethod(...args) {
    // const query = args.shift()
    // if (query)
    // let { pageNum } = this.pageInput;
    // pageNum++;
    // console.log("load more", pageNum);
    // this.handleRemoteMethod.apply(null, this.pageInput);
  }
}
